import { apiClient } from '@api';
import { UpcomingVisit, VisitDetail } from '@qmd-types/visits';
import { VisitMethod } from '@types';
import { Adyen } from '@quickmd-llc/design-system';
import '@quickmd-llc/design-system/features/adyen/styles.css';

interface CreateVisitParams {
  creditCardId: string;
  creditCardCvc: string | undefined;
  isIdentityVerificationDesired?: boolean;
  method: VisitMethod;
  reservationId: string;
  visitCreditAmount: number;
  referralCode?: string;
}
interface RescheduleVisitParams {
  method: VisitMethod;
  reservationId: string;
}

export async function createVisit(
  params: CreateVisitParams,
  adyenIsEnabled: boolean,
): Promise<VisitDetail> {
  const response = await apiClient.post(
    `/api/v1/visits${Adyen.getAdyenQueryString(adyenIsEnabled)}`,
    params,
  );
  return response.data;
}

export async function fetchUpcomingVisits(): Promise<UpcomingVisit[]> {
  const response = await apiClient.get('/api/v1/visits/upcoming');

  return response.data;
}

export async function fetchVisit(visitId: string): Promise<VisitDetail> {
  const response = await apiClient.get(`/api/v1/visits/${visitId}`);

  return response.data;
}

export async function rescheduleVisit(
  visitId: string,
  params: RescheduleVisitParams,
): Promise<null> {
  const response = await apiClient.put(
    `api/v1/visits/${visitId}/reschedule`,
    params,
  );
  return response.data;
}
